<template>
    <div class="about-mav">
        <p class="indent">Мисията на Алкомет е да бъде социално отговорна и екологично ориентирана компания, която предлага иновативни решения на своите клиенти и нови възможности на своите партньори. </p>
        <p class="indent">Основните ценности, които определят нашата компания са:</p>
        <div class="values-wrapper">
          <div class="value">
            <h3 class="strong">Лоялност </h3>
            <p>Да бъдем надежден партньор на клиентите, които са ни оказали доверие, предлагайки им възможно най-доброто обслужване и подкрепа за тяхното развитие.</p>
          </div>
          <div class="value">
            <h3 class="strong">Отговорност</h3>
            <p>В отношението ни към околната среда и обществото, нашите служители и нашите партньори.</p>
          </div>
          <div class="value">
            <h3 class="strong">Адаптивност</h3>
            <p>Да се приспособяваме към динамичните пазарни условия и постоянно променящите се потребности на нашите клиенти.</p>
          </div>
          <div class="value">
            <h3 class="strong">Прозрачност</h3>
            <p>Във всички наши действия, в бизнес стратегията и корпоративната ни политика, спазвайки най-високите стандарти на честност и професионализъм.</p>
          </div>
        </div>
        <app-share-button></app-share-button>
    </div>
</template>

<script>
import ShareButton from "../shared/ShareButton";
export default {
  components: {
    appShareButton: ShareButton
  }
};
</script>

<style scoped>
.about-mav p {
  font-size: 19px;
  line-height: 32px;
  margin: 15px auto;
  text-align: justify;
  width: 60%;
}
.values-wrapper {
  display: flex;
  flex-wrap: wrap;
  margin: 30px auto 0;
  width: 1000px;
}
.value {
  align-items: center;
  border-radius: 6px;
  background-color: #008bc2;
  display: flex;
  padding: 20px;
  flex-direction: column;
  margin: 15px 0;
  width: calc(50% - 15px);
}
.value:nth-child(odd) {
  margin-right: 30px;
}
.value:nth-child(3),
.value:nth-child(4) {
  margin-bottom: 0;
}
.value h3 {
  color: #fff;
  font-size: 24px;
  text-align: center;
  margin: 15px 0;
}
.value > p {
  color: #fff;
  margin: 0;
  padding: 15px;
  width: 100%;
}
@media screen and (max-width: 1440px) {
  .values-wrapper {
    width: 800px;
  }
}
@media screen and (max-width: 1280px) {
  .values-wrapper {
    width: 80%;
  }
}
@media screen and (max-width: 1000px) {
  .about-mav p {
    font-size: 16px;
    margin: 15px 0;
    padding: 0 30px;
    width: 100%;
  }
  .values-wrapper {
    width: 100%;
    padding: 0 30px;
  }
  .value {
    padding: 20px;
  }
  .value h3 {
    font-size: 20px;
    margin-top: 0;
  }
  .value p {
    font-size: 16px;
    line-height: 24px;
    margin: 0;
    padding: 0;
  }
}
@media screen and (max-width: 800px) {
  .value p {
    font-size: 14px;
    line-height: 20px;
  }
}
@media screen and (max-width: 600px) {
  .about-mav .value {
    width: 100%;
    margin: 10px 0;
  }
  .about-mav .value:last-child {
    margin-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/about/MissionAndValues.vue